<template>
    <div class="app">
      <v-card>
        <v-container fluid grid-list-lg>
            <div v-bind="text" class="font-weight-thin title">Ques: {{text.question}}</div> 
            <v-layout row>
                <v-flex xs12>
                    <highcharts :options="chartOptions" ref="chart"></highcharts>
                </v-flex>
            </v-layout>
        </v-container>
      </v-card>
  </div>
</template>
<script>
    import {Chart} from 'highcharts-vue';
    import Highcharts from 'highcharts'
    import wordcloudInit from 'highcharts/modules/wordcloud';

    wordcloudInit(Highcharts)

    export default {
        props:['dataset'],
         components: {
            highcharts: Chart
        },
        data: () => ({
            text:{
                question:null
            }, 
            chartOptions:{
                title: {
                    text: 'Word Cloud For Openended'
                },
                // subtitle: {
                //     text: 'Spread discrete values by randomizing the rendered position'
                // },
                series: [{
                type: 'wordcloud',
                data:[{
                    name: 'Lorem',
                    weight: 100
                }, {
                    name: 'Ipsum',
                    weight: 50
                }, {
                    name: 'Dolor',
                    weight: 41
                }],
                name: 'Occurrences'
                }],
                exporting: {
                    showTable: true
                }
            }
        }),
        watch: {
            dataset: function(){
            this.getTestData()  
            }
        },
        created() {
          this.getTestData();
        },
        methods: {
          getTestData() {
            const text = this.dataset.graphData,
            // const text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean bibendum erat ac justo sollicitudin, quis lacinia ligula fringilla. Pellentesque hendrerit, nisi vitae posuere condimentum, lectus urna accumsan libero, rutrum commodo mi lacus pretium erat. Phasellus pretium ultrices mi sed semper. Praesent ut tristique magna. Donec nisl tellus, sagittis ut tempus sit amet, consectetur eget erat. Sed ornare gravida lacinia. Curabitur iaculis metus purus, eget pretium est laoreet ut. Quisque tristique augue ac eros malesuada, vitae facilisis mauris sollicitudin. Mauris ac molestie nulla, vitae facilisis quam. Curabitur placerat ornare sem, in mattis purus posuere eget. Praesent non condimentum odio. Nunc aliquet, odio nec auctor congue, sapien justo dictum massa, nec fermentum massa sapien non tellus. Praesent luctus eros et nunc pretium hendrerit. In consequat et eros nec interdum. Ut neque dui, maximus id elit ac, consequat pretium tellus. Nullam vel accumsan lorem.',
            lines = text.split(/[, . ]+/g),
            // lines = text.split(/[,\ . ]+/g),
            data = lines.reduce((arr, word) => {
                let obj = Highcharts.find(arr, obj => obj.name === word);
                if (obj) {
                    obj.weight += 1;
                } else {
                    obj = {
                        name: word,
                        weight: 1
                    };
                    arr.push(obj);
                }
                return arr;
            }, []);
            this.chartOptions.series[0].data=data
            this.text.question = this.dataset.queSet.question;
            // console.log(text)
          }
          
        }
    }
</script>